import { Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import {
  buyerPremiumApi,
  getSellerFinalNegotiationDetailsApi,
  submitConfirmOffer,
} from "@/api/offers";
import "./ConfirmOffer.css";
import { ShimmerContentBlock } from "react-shimmer-effects";
import { useDispatch, useSelector } from "react-redux";
import { trackApiCall, trackButtonClick } from "@/utils/analytics";
import { fetchPDPBidCenterData } from "@/redux/PDP/pdpSlice";

const ConfirmOffer = ({ show, handleClose, listingId, onSuccess }) => {
  const [sellerFinal, setSellerFinal] = useState({});
  const [premium, setPremium] = useState({});
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.user);
  const [thankyou, setThankyou] = useState(false);

  const dispatch = useDispatch();

  const getSellerFinalNegotiationDetails = async () => {
    try {
      const data = await getSellerFinalNegotiationDetailsApi({ listingId });
      setSellerFinal(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const buyerPremium = async () => {
    try {
      const data = await buyerPremiumApi({
        listingId,
        amount: sellerFinal?.solicitationAmount,
      });
      setPremium(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const onClose = () => {
    if (thankyou) {
      dispatch(fetchPDPBidCenterData(listingId));
    }
    if (onSuccess) {
      onSuccess();
    }
    handleClose();
    trackButtonClick({
      eventName: "confirm_negotiation_cancel_click",
      eventCategory: "Confirm Offer Negotiation Wizard",
      eventSource: `on close modal`,
      eventLabel: `listingId: ${listingId} | bidId: ${sellerFinal?.bidId}`,
    });
  };

  const handleSubmit = async () => {
    try {
      trackButtonClick({
        eventName: "submit_best_bid_click",
        eventCategory: "Confirm Offer Negotiation Wizard",
        eventSource: `on confirm offer click`,
        eventLabel: `listingId: ${listingId} | bidId: ${
          sellerFinal?.bidId
        } | bidAmount:${
          premium?.bidAmountFormatted || sellerFinal?.solicitationAmount
        }`,
      });
      const data = await submitConfirmOffer({
        listingId,
        bidId: sellerFinal?.bidId,
        userId: user?.user?.realbidUserId,
      });
      if (data?.status === "SUCCESS") {
        setThankyou(true);
        // dispatch(fetchPDPBidCenterData(listingId));

        // handleClose();
        trackApiCall({
          eventName: "offer_negotiation_submit_success",
          eventCategory: "Confirm Offer Negotiation Wizard",
          eventSource: `on confirm offer click success`,
          eventLabel: `listingId: ${listingId} | bidId: ${sellerFinal?.bidId} | Place Offer Negotiation Call Success`,
        });
      } else {
        trackApiCall({
          eventName: "offer_negotiation_submit_failure",
          eventCategory: "Confirm Offer Negotiation Wizard",
          eventSource: `on confirm offer click failure`,
          eventLabel: `listingId: ${listingId} | bidId: ${sellerFinal?.bidId} | Place Offer Negotiation Call Failure`,
        });
      }
    } catch (error) {}
  };
  // ! this is the below line added for success msg and to be shown in same popup

  useEffect(() => {
    if (show) {
      setThankyou(false);
      setLoading(true);
      setSellerFinal({});
      setPremium({});
      getSellerFinalNegotiationDetails(); // Re-fetch every time
    }
  }, [show]);

  useEffect(() => {
    if (listingId) {
      getSellerFinalNegotiationDetails();
    }
  }, [listingId]);

  useEffect(() => {
    if (sellerFinal?.solicitationAmount) {
      setLoading(true);
      buyerPremium();
    }
  }, [sellerFinal?.solicitationAmount]);

  return (
    <Modal show={show} onHide={handleClose} size="lg" className="mt-5">
      <Modal.Header closeButton className="confirm-offer-title">
        <Modal.Title className="confirm-offer-head">
          Confirm Offer for{" "}
          {premium?.bidAmountFormatted ||
            `$ ${sellerFinal?.solicitationAmount}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <>
            <div>
              <ShimmerContentBlock
                title
                text
                cta
                thumbnailWidth={370}
                thumbnailHeight={370}
              />
            </div>
          </>
        ) : (
          <>
            {!thankyou ? (
              <div className="container p-3">
                <div className="d-flex confirm-offer-data">
                  <p className="conf-title">Buyer Name </p>
                  <p className="buyer-premium-value">
                    {sellerFinal?.sellerFinalNegotiationBuyerDetail?.firstName}{" "}
                    {sellerFinal?.sellerFinalNegotiationBuyerDetail?.lastName}
                  </p>
                </div>
                <div className="d-flex confirm-offer-data">
                  <p className="conf-title"> Your Bid Amount</p>
                  <div className="d-flex bid-value-div">
                    <button disabled className="offer-dis-btn">
                      -
                    </button>
                    <p className="offer-bid-value">
                      {premium?.bidAmountFormatted ||
                        `$ ${sellerFinal?.solicitationAmount}`}
                    </p>
                    <button disabled className="offer-dis-btn">
                      +
                    </button>
                  </div>
                </div>
                {/* <div className="d-flex confirm-offer-data">
                  <p className="conf-title">
                    Buyer's Premium {premium?.percentageFormatted}
                  </p>
                  <p className="buyer-premium-value">
                    {premium?.buyerPremiumFormatted}
                  </p>
                </div> */}
                {premium?.premiumPaidBy === "BUYER" && (
                  <>
                    {" "}
                    <div className="d-flex confirm-offer-data">
                      <p className="conf-title">
                        Buyer's Premium {premium?.percentageFormatted}
                      </p>
                      <p className="buyer-premium-value">
                        {premium?.buyerPremiumFormatted}
                      </p>
                    </div>
                  </>
                )}
                {/* <div className="d-flex confirm-offer-data total-due-div">
                  <p className="total-due">Total Due </p>
                  <p className="total-due-val">{premium?.totalDueFormatted}</p>
                </div> */}
                <div className="d-flex confirm-offer-data total-due-div">
                  <p className="total-due">Total Due </p>
                  <p className="total-due-val">
                    {premium?.premiumPaidBy === "BUYER"
                      ? premium?.totalDueFormatted
                      : premium?.bidAmountFormatted ||
                        `$ ${sellerFinal?.solicitationAmount}`}
                  </p>
                </div>

                <div className="offer-btns">
                  <button className="offer-btn-submit" onClick={handleSubmit}>
                    Submit
                  </button>
                  <button className="offer-btn-cncl" onClick={onClose}>
                    Close
                  </button>
                </div>
              </div>
            ) : (
              <div className="container p-3">
                <div className="d-flex confirm-offer-data">
                  <p className="conf-title">Buyer Name</p>
                  <p className="conf-title">
                    {user?.user?.userFirstName} {user?.user?.userLastName}
                  </p>
                </div>
                <div className="text-center p-4">Thank you for your bid</div>
                <div className="offer-btns">
                  <button className="offer-btn-cncl" onClick={onClose}>
                    Close
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmOffer;
